"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.PAST_DUE_NOTIFICATION_CHUNK_SIZE = exports.ALLOWED_PAYMENT_METHODS = exports.CONSUMER_ALLOWED_PAYMENT_METHODS = exports.GENDER_NAME_DICT = exports.DEFAULT_USER_COUNT = exports.EMPTY_USER_COUNT = exports.ALLOWED_PAYMENT_INTENT_STATUSES = void 0;
const payment_enums_1 = require("../../../payment/types/enums/payment.enums");
const enums_service_1 = require("../../../services/enums.service");
exports.ALLOWED_PAYMENT_INTENT_STATUSES = ['processing', 'succeeded'];
exports.EMPTY_USER_COUNT = { male: 0, female: 0, other: 0 };
exports.DEFAULT_USER_COUNT = { male: 0, female: 0, other: 1 };
exports.GENDER_NAME_DICT = {
    [enums_service_1.GenderEnum.MALE]: 'male',
    [enums_service_1.GenderEnum.FEMALE]: 'female',
    [enums_service_1.GenderEnum.OTHER]: 'other',
};
exports.CONSUMER_ALLOWED_PAYMENT_METHODS = [
    payment_enums_1.PaymentMethodTypeEnum.ACH,
    payment_enums_1.PaymentMethodTypeEnum.CARD,
    payment_enums_1.PaymentMethodTypeEnum.BALANCE,
];
exports.ALLOWED_PAYMENT_METHODS = [
    payment_enums_1.PaymentMethodTypeEnum.CARD,
    payment_enums_1.PaymentMethodTypeEnum.ACH,
    payment_enums_1.PaymentMethodTypeEnum.CASH,
    payment_enums_1.PaymentMethodTypeEnum.CHECK,
    payment_enums_1.PaymentMethodTypeEnum.BALANCE,
    payment_enums_1.PaymentMethodTypeEnum.CARD_ON_TERMINAL,
    payment_enums_1.PaymentMethodTypeEnum.GIFT_CARD,
    payment_enums_1.PaymentMethodTypeEnum.OTHER,
];
exports.PAST_DUE_NOTIFICATION_CHUNK_SIZE = 500;
//# sourceMappingURL=purchase.consts.js.map